import initEpicBoards from 'ee/epic_boards';
import ShortcutsNavigation from '~/behaviors/shortcuts/shortcuts_navigation';

new ShortcutsNavigation(); // eslint-disable-line no-new
initEpicBoards();
